import { render, staticRenderFns } from "./descriptionSpecialtyEnrollmentCommittee.vue?vue&type=template&id=75d34167&scoped=true&"
import script from "./descriptionSpecialtyEnrollmentCommittee.vue?vue&type=script&lang=js&"
export * from "./descriptionSpecialtyEnrollmentCommittee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d34167",
  null
  
)

export default component.exports